import '../../assets/info.css';
import { jsx as n } from "react/jsx-runtime";
import { Typography as f } from "@datamole/wds-component-typography";
import a from "clsx";
import { forwardRef as e } from "react";
const m = "_info_137d0_1", i = {
  info: m
}, c = e((o, r) => {
  const { className: t, ...s } = o;
  return /* @__PURE__ */ n(
    f,
    {
      variant: "xs",
      colorShade: "lighter",
      color: "default",
      ...s,
      ref: r,
      className: a(t, i.info)
    }
  );
});
c.displayName = "Combobox.Content.Info";
export {
  c as Info
};
